let data_product = [
    {
        id : 1,
        name : "KOTTY Women Stretchable Regular Fit Sweatshirt",
        image : "https://assets.ajio.com/medias/sys_master/root/20231123/rCVV/655f7c75afa4cf41f59b0b32/-473Wx593H-466821089-green-MODEL2.jpg",
        new_price : 85.00,
        old_price : 120.00
    },
    {
        id : 2,
        name : "DNMX Women Quilted Zip-Front Regular Fit Jacket",
        image : "https://assets.ajio.com/medias/sys_master/root/20231005/mrgy/651ed3d0afa4cf41f52a227e/-1117Wx1400H-443015253-navy-MODEL.jpg",
        new_price : 85.00,
        old_price : 120.00
    },
    {
        id : 3,
        name : "GAP Women Brand Print Relaxed Fit Round-Neck Sweatshirt",
        image : "https://assets.ajio.com/medias/sys_master/root/20231124/YmHD/6560b565afa4cf41f59d1f39/-473Wx593H-442253180-purple-MODEL.jpg",
        new_price : 85.00,
        old_price : 120.00
    },
    {
        id : 4,
        name : "FYRE ROSE Checked Slim Fit Double-Breasted Blazer",
        image : "https://assets.ajio.com/medias/sys_master/root/20230911/Epao/64ff47b3afa4cf41f5d8d5f0/-1117Wx1400H-469495630-pink-MODEL5.jpg",
        new_price : 85.00,
        old_price : 120.00
    }
]

export default data_product